export enum VisibilityTypes {
    NOT_VISIBLE = 0,
    VISIBLE_TO_PUBLIC = 1,
    VISIBLE_TO_ADMINISTRATION = 2,
    ALWAYS_VISIBLE = 3,
}
